<template>
  <div>
    <section class="panel panel-default" style="margin-bottom: 0px;" v-if="isAdmin('stay')">
      <header class="panel-heading" style="padding: 10px;">
        <div class="panel-actions" style="top: 7px;">
          <a href="#accessDetailSearchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
        </div>
        <h4 class="panel-title">查詢條件</h4>
      </header>
      <div id="accessDetailSearchArea" class="panel-collapse collapse">
        <div class="panel-body">
          <div class="row form-group">
            <div class="col-md-12 ">
              <div class="col-md-4">
                <label class="col-md-4">日期區間</label>
                <div class="col-md-8">
                  <datepicker :format="customFormatter" :language="zh" input-class="form-control"
                              v-model="search.accessDateBegin" name="accessDateBegin"
                              :style="{width:'46%', display:'inline-block'}"
                              @closed="endState.disabledDates.to = search.accessDateBegin; (search.accessDateEnd < search.accessDateBegin ? search.accessDateEnd = ``: search.accessDateEnd = search.accessDateEnd)"/>
                  <span style="width:2%;">~</span>
                  <datepicker :format="customFormatter" :language="zh" input-class="form-control"
                              v-model="search.accessDateEnd" name="accessDateEnd"
                              :style="{width:'46%', display:'inline-block'}" :disabled-dates="endState.disabledDates"/>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">棟別</label>
                <div class="col-md-8">
                  <input type="text" v-model="search.buildingName" class="form-control"/>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">樓層</label>
                <div class="col-md-8">
                  <input type="text" v-model="search.floorNumber" class="form-control"/>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12 ">
              <div class="col-md-4">
                <label class="col-md-4">房號</label>
                <div class="col-md-8">
                  <input type="text" v-model="search.roomNumber" class="form-control"/>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">床號</label>
                <div class="col-md-8">
                  <input type="text" v-model="search.bedNumber" class="form-control"/>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">學號</label>
                <div class="col-md-8">
                  <input type="text" v-model="search.studentId" class="form-control"/>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12 ">
              <div class="col-md-4">
                <label class="col-md-4">姓名</label>
                <div class="col-md-8">
                  <input type="text" v-model="search.studentName" class="form-control"/>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-offset-4 col-md-4 ">
              <div class="col-md-offset-2 col-md-4">
                <button type="button" class="btn btn-default btn-block" @click="onClearSearch">清除</button>
              </div>
              <div class="col-md-4">
                <button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="panel">
      <header class="panel-heading">
        <h2 class="panel-title">宿舍房門、房間門</h2>
      </header>
      <div class="panel-body container-fluid">
        <div class="row">
          <div class="col-md-12">
            <table class="table table-no-more table-bordered table-striped mb-none">
              <thead>
              <tr>
                <th class="text-center" style="width:16%;">刷卡時間</th>
                <th class="text-center" style="width:12%;">棟別</th>
                <th class="text-center" style="width:8%;">樓層</th>
                <th class="text-center" style="width:10%;">房號</th>
                <th class="text-center" style="width:8%;">床號</th>
                <th class="text-center" style="width:12%;">學號</th>
                <th class="text-center" style="width:14%;">姓名</th>
                <th class="text-center" style="width:20%;">備註</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in accessDetailList" :key="index">
                <td class="text-center" data-title="刷卡時間">{{ customFormatter(item.accessDate, "YYYY/MM/DD HH:mm:ss") }}</td>
                <td class="text-center" data-title="棟別">{{ item.buildingName }}</td>
                <td class="text-center" data-title="樓層">{{ item.floorNumber }}</td>
                <td class="text-center" data-title="房號">{{ item.roomNumber }}</td>
                <td class="text-center" data-title="床號">{{ item.bedNumber }}</td>
                <td class="text-center" data-title="學號">{{ item.studentId }}</td>
                <td class="text-center" data-title="姓名">{{ item.studentName }}</td>
                <td class="text-center" data-title="備註">{{ item.remark }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      accessDetailList: [],
      page: 1,
      pageSize: 10,
      totalPage: 0,
      search: {
        accessDateBegin: "",
        accessDateEnd: "",
        buildingName: "",
        floorNumber: "",
        roomNumber: "",
        bedNumber: "",
        studentId: "",
        studentName: ""
      },
      endState: {
        disabledDates: {
          to: null
        }
      },
    }
  },
  mounted() {
    this.gridInit();
  },
  methods: {
    async gridInit() {
      try {
        const resp = await this.$axios.post("/api/Menjin/access-detail", {
          page: this.page,
          pageSize: this.pageSize,
          model: { ...this.search }
        });
        this.accessDetailList = resp.data.rows;
        this.page = resp.data.page;
        this.totalPage = resp.data.total;
      } catch (e) {
        alert('查詢失敗，請稍後再試（外部資料庫可能無法連線）');
      }
    },
    updateGrid(page) {
      //更新Grid 必需
      this.page = page;
      this.gridInit();
    },
    onClearSearch() {
      this.endState.disabledDates.to = null;
      this.search = {
        accessDateBegin: "",
        accessDateEnd: "",
        buildingName: "",
        floorNumber: "",
        roomNumber: "",
        bedNumber: "",
        studentId: "",
        studentName: ""
      }
    }
  }
}
</script>
